import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

/**
 * Type defintion for multi date picker on change result value.
 */
export type MultiDatePickerResult = [Date | null, Date | null];

interface InputMultiDatePickerProps {
    className?: string,
    disabled?: boolean,
    placeholder?: string,
    errorMessage?: string,
    readOnly?: boolean,
    onChange?: (dateRange: MultiDatePickerResult) => void
}

/**
 * Input Multi Date Picker component
 * @param param0 
 * @returns 
 */
export const InputMultiDatePicker: React.FunctionComponent<InputMultiDatePickerProps> = (props) => {
    const [dateRange, setDateRange] = useState<MultiDatePickerResult>([null, null]);
    const [startDate, endDate] = dateRange;

    /**
     * Handle on change multi date picker input.
     * @param dateRange 
     */
    const onChangeInput = (dateRange: MultiDatePickerResult) => {
        if (dateRange) {
            setDateRange(dateRange);

            if (props.onChange) {
                props.onChange(dateRange);
            }
        }
    }

    return (
        <React.Fragment>
            <ReactDatePicker
                wrapperClassName="w-100"
                className={props.className}
                placeholderText={props.placeholder}
                disabled={props.disabled}
                readOnly={props.readOnly}
                selectsRange={true}
                dateFormat="dd/MM/yyyy"
                startDate={startDate}
                endDate={endDate}
                onChange={onChangeInput}
                onChangeRaw={(e) => e.preventDefault()}
                isClearable={true}
            />
            {
                props.errorMessage &&
                <p className="text-danger small">{props.errorMessage}</p>
            }
        </React.Fragment>);
}

InputMultiDatePicker.defaultProps = {
    className: 'form-control oa-input',
}